import { ballLabel, letterForNumber, masterBoardColumns, type BingoLetter } from '@/lib/bingo';

const LETTERS: BingoLetter[] = ['B', 'I', 'N', 'G', 'O'];

interface Props {
    drawn: Set<number>;
    latest?: number | null;
}

export function MasterBoard({ drawn, latest = null }: Props) {
    const cols = masterBoardColumns();

    return (
        <div className="w-master">
            <div className="w-master-letters">
                {LETTERS.map((l) => (
                    <span key={l} className={`w-letter w-letter-${l.toLowerCase()}`}>
                        {l}
                    </span>
                ))}
            </div>
            <div className="w-master-grid">
                {LETTERS.map((letter) => (
                    <div key={letter} className="w-master-col">
                        {cols[letter].map((n) => {
                            const isDrawn = drawn.has(n);
                            const isLatest = latest === n;
                            return (
                                <div
                                    key={n}
                                    className={[
                                        'w-master-cell',
                                        isDrawn ? 'called' : '',
                                        isLatest ? 'latest' : '',
                                    ]
                                        .filter(Boolean)
                                        .join(' ')}
                                    title={ballLabel(n)}
                                >
                                    {n}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}

export function LastCalls({ numbers, max = 4 }: { numbers: number[]; max?: number }) {
    const recent = numbers.slice(-max).reverse();
    const empty = max - recent.length;

    return (
        <div className="w-last-calls">
            {recent.map((n, i) => {
                const letter = letterForNumber(n);
                return (
                    <div key={`${n}-${i}`} className={`w-call-ball w-call-${letter?.toLowerCase() ?? 'b'}`}>
                        {ballLabel(n)}
                    </div>
                );
            })}
            {Array.from({ length: empty }).map((_, i) => (
                <div key={`empty-${i}`} className="w-call-ball w-call-empty">
                    —
                </div>
            ))}
        </div>
    );
}
